// ...existing code...
import { FC } from "react";
import styles from "./Messages.module.css";
import { Message } from "./Message";
import { AnimatePresence, motion } from "motion/react";
import { useBackendContextMessages } from "../../services/backend/backendContextProvider";

export const Messages: FC = () => {

    const { messages } = useBackendContextMessages();

    const containerVariants = {
        hidden: {},
        visible: {
            transition: { staggerChildren: 0.06 }
        }
    };

    return <div className={styles.container}>
        <AnimatePresence initial={false} mode="popLayout">
            {messages.map((message) => (
                <motion.div
                    key={`${message.timestamp}-${message.text}`}
                    layout // animuje změny layoutu při přeskupení
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    variants={containerVariants}
                >
                    <Message message={message} />
                </motion.div>
            ))}
        </AnimatePresence>
    </div>;

}